import { RestApiService } from './rest-api-service';
import { localStorageService } from './local-storage-service';
import { authenticationService } from './authentication-service';
import { accountSubscription } from './account-subscription-service';

export const restApiService = new RestApiService(localStorageService, accountSubscription, authenticationService);
